<template>
  <div class="table-responsive mt-3 mb-0">
    <!-- Calendar -->
    <table class="table table-bordered custom-table mb-0">
      <thead class="thead-light header-date">
        <tr>
          <th class="time-td"></th>
          <th v-for="(item, i) in data" :key="i">{{ item.DateDisplay }}</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td class="time-td">12am</td>
          <td
            v-for="(item, i) in data"
            class="content-td"
            :key="'12am' + i"
            @dblclick="
              showAddEvent(item.CalendarDate, '12', '00', 'AM', $event)
            "
            @click.right="
              showAddMenu(item.CalendarDate, '12', '00', 'AM', $event)
            "
          ></td>
        </tr>
        <tr>
          <td class="time-td">1am</td>
          <td
            v-for="(item, i) in data"
            class="content-td"
            :key="'1am' + i"
            @dblclick="showAddEvent(item.CalendarDate, '1', '00', 'AM', $event)"
            @click.right="
              showAddMenu(item.CalendarDate, '1', '00', 'AM', $event)
            "
          ></td>
        </tr>
        <tr>
          <td class="time-td">2am</td>
          <td
            v-for="(item, i) in data"
            class="content-td"
            :key="'2am' + i"
            @dblclick="showAddEvent(item.CalendarDate, '2', '00', 'AM', $event)"
            @click.right="
              showAddMenu(item.CalendarDate, '2', '00', 'AM', $event)
            "
          ></td>
        </tr>
        <tr>
          <td class="time-td">3am</td>
          <td
            v-for="(item, i) in data"
            class="content-td"
            :key="'3am' + i"
            @dblclick="showAddEvent(item.CalendarDate, '3', '00', 'AM', $event)"
            @click.right="
              showAddMenu(item.CalendarDate, '3', '00', 'AM', $event)
            "
          ></td>
        </tr>
        <tr>
          <td class="time-td">4am</td>
          <td
            v-for="(item, i) in data"
            class="content-td"
            :key="'4am' + i"
            @dblclick="showAddEvent(item.CalendarDate, '4', '00', 'AM', $event)"
            @click.right="
              showAddMenu(item.CalendarDate, '4', '00', 'AM', $event)
            "
          ></td>
        </tr>
        <tr>
          <td class="time-td">5am</td>
          <td
            v-for="(item, i) in data"
            class="content-td"
            :key="'5am' + i"
            @dblclick="showAddEvent(item.CalendarDate, '5', '00', 'AM', $event)"
            @click.right="
              showAddMenu(item.CalendarDate, '5', '00', 'AM', $event)
            "
          ></td>
        </tr>
        <tr>
          <td class="time-td">6am</td>
          <td
            v-for="(item, i) in data"
            class="content-td"
            :key="'6am' + i"
            @dblclick="showAddEvent(item.CalendarDate, '6', '00', 'AM', $event)"
            @click.right="
              showAddMenu(item.CalendarDate, '6', '00', 'AM', $event)
            "
          ></td>
        </tr>
        <tr>
          <td class="time-td">7am</td>
          <td
            v-for="(item, i) in data"
            class="content-td"
            :key="'7am' + i"
            @dblclick="showAddEvent(item.CalendarDate, '7', '00', 'AM', $event)"
            @click.right="
              showAddMenu(item.CalendarDate, '7', '00', 'AM', $event)
            "
          ></td>
        </tr>
        <tr>
          <td class="time-td">8am</td>
          <td
            v-for="(item, i) in data"
            class="content-td"
            :key="'8am' + i"
            @dblclick="showAddEvent(item.CalendarDate, '8', '00', 'AM', $event)"
            @click.right="
              showAddMenu(item.CalendarDate, '8', '00', 'AM', $event)
            "
          ></td>
        </tr>
        <tr>
          <td class="time-td">9am</td>
          <td
            v-for="(item, i) in data"
            class="content-td"
            :key="'9am' + i"
            @dblclick="showAddEvent(item.CalendarDate, '9', '00', 'AM', $event)"
            @click.right="
              showAddMenu(item.CalendarDate, '9', '00', 'AM', $event)
            "
          ></td>
        </tr>
        <tr>
          <td class="time-td">10am</td>
          <td
            v-for="(item, i) in data"
            class="content-td"
            :key="'10am' + i"
            @dblclick="showAddEvent(item.CalendarDate, '1', '00', 'AM', $event)"
            @click.right="
              showAddMenu(item.CalendarDate, '10', '00', 'AM', $event)
            "
          ></td>
        </tr>
        <tr>
          <td class="time-td">11am</td>
          <td
            v-for="(item, i) in data"
            class="content-td"
            :key="'11am' + i"
            @dblclick="
              showAddEvent(item.CalendarDate, '11', '00', 'AM', $event)
            "
            @click.right="
              showAddMenu(item.CalendarDate, '11', '00', 'AM', $event)
            "
          ></td>
        </tr>
        <tr>
          <td class="time-td">12pm</td>
          <td
            v-for="(item, i) in data"
            class="content-td"
            :key="'12pm' + i"
            @dblclick="
              showAddEvent(item.CalendarDate, '12', '00', 'PM', $event)
            "
            @click.right="
              showAddMenu(item.CalendarDate, '12', '00', 'PM', $event)
            "
          ></td>
        </tr>
        <tr>
          <td class="time-td">1pm</td>
          <td
            v-for="(item, i) in data"
            class="content-td"
            :key="'1pm' + i"
            @dblclick="showAddEvent(item.CalendarDate, '1', '00', 'PM', $event)"
            @click.right="
              showAddMenu(item.CalendarDate, '1', '00', 'PM', $event)
            "
          ></td>
        </tr>
        <tr>
          <td class="time-td">2pm</td>
          <td
            v-for="(item, i) in data"
            class="content-td"
            :key="'2pm' + i"
            @dblclick="showAddEvent(item.CalendarDate, '2', '00', 'PM', $event)"
            @click.right="
              showAddMenu(item.CalendarDate, '2', '00', 'PM', $event)
            "
          ></td>
        </tr>
        <tr>
          <td class="time-td">3pm</td>
          <td
            v-for="(item, i) in data"
            class="content-td"
            :key="'3pm' + i"
            @dblclick="showAddEvent(item.CalendarDate, '3', '00', 'PM', $event)"
            @click.right="
              showAddMenu(item.CalendarDate, '3', '00', 'PM', $event)
            "
          ></td>
        </tr>
        <tr>
          <td class="time-td">4pm</td>
          <td
            v-for="(item, i) in data"
            class="content-td"
            :key="'4pm' + i"
            @dblclick="showAddEvent(item.CalendarDate, '4', '00', 'PM', $event)"
            @click.right="
              showAddMenu(item.CalendarDate, '4', '00', 'PM', $event)
            "
          ></td>
        </tr>
        <tr>
          <td class="time-td">5pm</td>
          <td
            v-for="(item, i) in data"
            class="content-td"
            :key="'5pm' + i"
            @dblclick="showAddEvent(item.CalendarDate, '5', '00', 'PM', $event)"
            @click.right="
              showAddMenu(item.CalendarDate, '5', '00', 'PM', $event)
            "
          ></td>
        </tr>
        <tr>
          <td class="time-td">6pm</td>
          <td
            v-for="(item, i) in data"
            class="content-td"
            :key="'6pm' + i"
            @dblclick="showAddEvent(item.CalendarDate, '6', '00', 'PM', $event)"
            @click.right="
              showAddMenu(item.CalendarDate, '6', '00', 'PM', $event)
            "
          ></td>
        </tr>
        <tr>
          <td class="time-td">7pm</td>
          <td
            v-for="(item, i) in data"
            class="content-td"
            :key="'7pm' + i"
            @dblclick="showAddEvent(item.CalendarDate, '7', '00', 'PM', $event)"
            @click.right="
              showAddMenu(item.CalendarDate, '7', '00', 'PM', $event)
            "
          ></td>
        </tr>
        <tr>
          <td class="time-td">8pm</td>
          <td
            v-for="(item, i) in data"
            class="content-td"
            :key="'8pm' + i"
            @dblclick="showAddEvent(item.CalendarDate, '8', '00', 'PM', $event)"
            @click.right="
              showAddMenu(item.CalendarDate, '8', '00', 'PM', $event)
            "
          ></td>
        </tr>
        <tr>
          <td class="time-td">9pm</td>
          <td
            v-for="(item, i) in data"
            class="content-td"
            :key="'9pm' + i"
            @dblclick="showAddEvent(item.CalendarDate, '9', '00', 'PM', $event)"
            @click.right="
              showAddMenu(item.CalendarDate, '9', '00', 'PM', $event)
            "
          ></td>
        </tr>
        <tr>
          <td class="time-td">10pm</td>
          <td
            v-for="(item, i) in data"
            class="content-td"
            :key="'10pm' + i"
            @dblclick="
              showAddEvent(item.CalendarDate, '10', '00', 'PM', $event)
            "
            @click.right="
              showAddMenu(item.CalendarDate, '10', '00', 'PM', $event)
            "
          ></td>
        </tr>
        <tr>
          <td class="time-td">11pm</td>
          <td
            v-for="(item, i) in data"
            class="content-td"
            :key="'11pm' + i"
            @dblclick="
              showAddEvent(item.CalendarDate, '11', '00', 'PM', $event)
            "
            @click.right="
              showAddMenu(item.CalendarDate, '11', '00', 'PM', $event)
            "
          ></td>
        </tr>
      </tbody>
    </table>
    <!-- /Calendar -->

    <!-- Events -->
    <template v-for="item in data">
      <div
        v-for="rec in item.Events"
        :key="rec.Id"
        :id="`event${rec.Id}`"
        :class="
          !rec.IsPublicHoliday
            ? rec.Id == selectedEventId
              ? 'event-div selected'
              : 'event-div'
            : 'event-div border-gray'
        "
        :style="`background-color:${rec.Color}`"
        @click="selectEvent(rec, $event)"
        @dblclick="showEditEvent(rec, $event)"
        @click.right="showEditMenu(rec, $event)"
      >
        <template v-if="!rec.IsPublicHoliday">
          <span class="time-span">{{ rec.StartTime }}</span>
          <br />
        </template>
        <span class="event-span">{{ rec.EventName }}</span>
      </div>
    </template>
    <!-- /Events -->

    <!-- Add-Edit Event Modal -->
    <div class="modal custom-modal fade" id="addEvent" role="dialog">
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header pt-4">
            <h5 class="modal-title">{{ id ? "Edit" : "Add" }} Event</h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body pt-3">
            <form @submit.prevent="save">
              <div class="form-group">
                <label class="mb-0">
                  Event Name<span class="text-danger">*</span>
                </label>
                <input
                  type="text"
                  v-model="eventName"
                  class="form-control"
                  maxlength="100"
                  required
                />
              </div>
              <div class="form-group">
                <label class="mb-0">Location</label>
                <input
                  type="text"
                  v-model="location"
                  class="form-control"
                  maxlength="100"
                />
              </div>
              <div class="form-group">
                <label class="mb-0">
                  Date<span class="text-danger">*</span>
                </label>
                <input
                  type="date"
                  class="form-control"
                  v-model="date"
                  required
                />
              </div>
              <div class="form-group">
                <div class="row">
                  <div class="form-group col-md-6 mb-0">
                    <label class="mb-0">
                      Start Time<span class="text-danger">*</span>
                    </label>
                    <div class="d-flex align-items-center">
                      <select
                        v-model="startHour"
                        class="form-control form-control-sm fit-content"
                        required
                      >
                        <option value>0</option>
                        <option
                          v-for="item in timingHours"
                          :value="item"
                          :key="item"
                        >
                          {{ item }}
                        </option>
                      </select>
                      <span class="mx-1">:</span>
                      <select
                        v-model="startMinute"
                        class="form-control form-control-sm fit-content"
                      >
                        <option
                          v-for="item in timingMinutes"
                          :value="item"
                          :key="item"
                        >
                          {{ item }}
                        </option>
                      </select>
                      <select
                        v-model="startTimePart"
                        class="form-control form-control-sm ml-2 fit-content"
                      >
                        <option value="AM">AM</option>
                        <option value="PM">PM</option>
                      </select>
                    </div>
                  </div>
                  <div class="form-group col-md-6 mb-0">
                    <label class="mb-0">
                      End Time<span class="text-danger">*</span>
                    </label>
                    <div class="d-flex align-items-center">
                      <select
                        v-model="endHour"
                        class="form-control form-control-sm fit-content"
                        required
                      >
                        <option value>0</option>
                        <option
                          v-for="item in timingHours"
                          :value="item"
                          :key="item"
                        >
                          {{ item }}
                        </option>
                      </select>
                      <span class="mx-1">:</span>
                      <select
                        v-model="endMinute"
                        class="form-control form-control-sm fit-content"
                      >
                        <option
                          v-for="item in timingMinutes"
                          :value="item"
                          :key="item"
                        >
                          {{ item }}
                        </option>
                      </select>
                      <select
                        v-model="endTimePart"
                        class="form-control form-control-sm ml-2 fit-content"
                      >
                        <option value="AM">AM</option>
                        <option value="PM">PM</option>
                      </select>
                    </div>
                  </div>
                </div>
              </div>
              <div class="form-group">
                <label class="mb-0">Notes</label>
                <textarea
                  class="form-control"
                  maxlength="200"
                  v-model="notes"
                ></textarea>
              </div>
              <!-- Button -->
              <div class="submit-section mt-4">
                <button type="submit" class="btn btn-primary submit-btn">
                  {{ id ? "Update" : "Add" }}
                </button>
              </div>
              <!-- /Button -->
            </form>
          </div>
        </div>
      </div>
    </div>
    <!-- /Add-Edit Event Modal -->

    <!-- Add Menu Right Click -->
    <div
      tabindex="-1"
      class="card m-0 menu"
      id="addMenu"
      ref="addMenu"
      :style="`top:${top};left:${left};display:none`"
      @blur="closeAddMenu"
    >
      <div class="card-body p-0">
        <div
          @click="showAddEvent(null, null, null, null, $event)"
          class="menu-item"
        >
          <i class="fa fa-plus-circle mr-1"></i>Add Event
        </div>
      </div>
    </div>
    <!-- /Add Menu Right Click -->

    <!-- Edit Menu Right Click -->
    <div
      tabindex="-1"
      class="card m-0 menu"
      :id="'editMenu'"
      :ref="'editMenu'"
      :style="`top:${top};left:${left};display:none`"
      @blur="closeEditMenu"
    >
      <div class="card-body p-0">
        <div @click="showEditEvent(null, $event)" class="menu-item">
          <i class="fa fa-pencil mr-1"></i>Edit
        </div>
        <div @click="remove" class="menu-item">
          <i class="fa fa-trash-o mr-1"></i>Delete
        </div>
      </div>
    </div>
    <!-- /Edit Menu Right Click -->
  </div>
</template>

<script>
import API from "../../../http-common.js";
import $ from "jquery";
export default {
  props: ["selectedDate", "instructorId", "selectedCountries"],
  data() {
    return {
      data: [],
      //for modal
      id: "",
      eventName: "",
      location: "",
      date: "",
      startHour: "",
      startMinute: "00",
      startTimePart: "AM",
      endHour: "",
      endMinute: "00",
      endTimePart: "AM",
      notes: "",
      country: "",
      //for right click menu
      top: "0px",
      left: "0px",
      scrollTop: 0,
      selectedEventId: "",
    };
  },
  watch: {
    "$store.state.expandSidebar": function (val) {
      window.setTimeout(() => {
        this.loadCalendar(this.data);
      }, 300);
    },
  },
  computed: {
    tokenObj() {
      let data = JSON.parse(localStorage.getItem("cbstoken"));
      return data;
    },
    timingHours() {
      let hours = [];
      for (let i = 1; i <= 12; i++) {
        hours.push(i);
      }
      return hours;
    },
    timingMinutes() {
      let minutes = [];
      for (let i = 0; i <= 59; i++) {
        minutes.push(i.toString().padStart(2, "0"));
      }
      return minutes;
    },
  },
  methods: {
    //modal add and edit
    showAddEvent(date, startHour, startMinute, startTimePart, event) {
      event.preventDefault();
      this.id = "";
      this.eventName = "";
      this.location = "";
      if (date && startHour && startMinute && startTimePart) {
        this.date = date;
        this.startHour = startHour;
        this.startMinute = startMinute;
        this.startTimePart = startTimePart;
      }
      this.endHour = "";
      this.endMinute = "00";
      this.endTimePart = "AM";
      this.notes = "";
      $("#addMenu").hide();
      // $("#addEvent").modal("show");
      let obj = {
        date: this.date,
        startHour: this.startHour,
        startMinute: this.startMinute,
        startTimePart: this.startTimePart,
      };
      this.$emit("showAddEventFromComponent", obj);
    },
    showEditEvent(payload, event) {
      event.preventDefault();
      event.cancelBubble = true;
      if (event.stopPropagation) event.stopPropagation();
      if (payload) {
        this.id = payload.Id;
        this.eventName = payload.EventName;
        this.location = payload.Location;
        this.date = payload.CalendarDate;
        this.startHour = payload.StartHour;
        this.startMinute = payload.StartMinute.toString().padStart(2, "0");
        this.startTimePart = payload.StartTimePart;
        this.endHour = payload.EndHour;
        this.endMinute = payload.EndMinute.toString().padStart(2, "0");
        this.endTimePart = payload.EndTimePart;
        this.notes = payload.Notes;
        if (payload.IsPublicHoliday) {
          let obj = {
            eventName: payload.EventName,
            date: payload.DateStartDisplay,
            country: payload.Country,
          };
          this.$emit("showPublicHoliday", obj);
          return;
        }
      }
      $("#editMenu").hide();
      // $("#addEvent").modal("show");
      let obj = {
        id: this.id,
        eventName: this.eventName,
        location: this.location,
        date: this.date,
        startHour: this.startHour,
        startMinute: this.startMinute,
        startTimePart: this.startTimePart,
        endHour: this.endHour,
        endMinute: this.endMinute,
        endTimePart: this.endTimePart,
        notes: this.notes,
      };
      this.$emit("showEditEventFromComponent", obj);
    },
    selectEvent(payload, event) {
      if (!payload.IsPublicHoliday) {
        this.selectedEventId = payload.Id;
        this.$emit("selectEvent", payload);
      }
    },
    //menu add and edit
    updateCalendar() {
      window.setTimeout(() => {
        if (this.data && this.data.length) {
          this.loadCalendar(this.data);
        }
      }, 200);
    },
    updateScrollTop() {
      this.scrollTop = window.scrollY || document.documentElement.scrollTop;
    },
    showAddMenu(date, startHour, startMinute, startTimePart, event) {
      event.preventDefault();
      this.date = date;
      this.startHour = startHour;
      this.startMinute = startMinute;
      this.startTimePart = startTimePart;
      this.$nextTick(() => {
        $(document).scrollTop(this.scrollTop);
      });
      $("#addMenu").show();
      this.$refs.addMenu.focus();
      let calDivOuterHeight = $(".cal-div").outerHeight();
      let calDivOuterWidth = $(".cal-div").outerWidth();
      if (calDivOuterHeight >= 300) {
        calDivOuterHeight = 0;
      } else {
        calDivOuterHeight = calDivOuterHeight + 20;
        calDivOuterWidth = 0;
      }
      let allAboveElementsHeight =
        60 + 30 + 36.2 + 30 + 20 + 42.41 + 16 + calDivOuterHeight;
      let top = event.y + this.scrollTop - allAboveElementsHeight;

      let sideBarOuterWidth = $(".sidebar").outerWidth();
      let allLeftElementsWidth = sideBarOuterWidth + 30 + calDivOuterWidth;
      let addMenuOuterWidth = $(".menu").outerWidth();
      let timeTdOuterWidth = $(".time-td").outerWidth();
      let contentTdOuterWidth = $(".content-td").outerWidth() * 7;
      let left = event.x - allLeftElementsWidth;
      if (left >= timeTdOuterWidth + contentTdOuterWidth - addMenuOuterWidth) {
        left = left - (addMenuOuterWidth + 5);
      }
      this.top = top + "px";
      this.left = left + "px";
    },
    closeAddMenu() {
      $("#addMenu").hide();
    },
    showEditMenu(payload, event) {
      event.preventDefault();
      if (payload.IsPublicHoliday) return;
      this.selectedEventId = payload.Id;
      this.$emit("selectEvent", payload);
      this.id = payload.Id;
      this.eventName = payload.EventName;
      this.location = payload.Location;
      this.date = payload.CalendarDate;
      this.startHour = payload.StartHour;
      this.startMinute = payload.StartMinute.toString().padStart(2, "0");
      this.startTimePart = payload.StartTimePart;
      this.endHour = payload.EndHour;
      this.endMinute = payload.EndMinute.toString().padStart(2, "0");
      this.endTimePart = payload.EndTimePart;
      this.notes = payload.Notes;
      this.$nextTick(() => {
        $(document).scrollTop(this.scrollTop);
      });
      $("#editMenu").show();
      this.$refs.editMenu.focus();
      let calDivOuterHeight = $(".cal-div").outerHeight();
      let calDivOuterWidth = $(".cal-div").outerWidth();
      if (calDivOuterHeight >= 300) {
        calDivOuterHeight = 0;
      } else {
        calDivOuterHeight = calDivOuterHeight + 20;
        calDivOuterWidth = 0;
      }
      let allAboveElementsHeight =
        60 + 30 + 36.2 + 30 + 20 + 42.41 + 16 + calDivOuterHeight;
      let top = event.y + this.scrollTop - allAboveElementsHeight;

      let sideBarOuterWidth = $(".sidebar").outerWidth();
      let allLeftElementsWidth = sideBarOuterWidth + 30 + calDivOuterWidth;
      let editMenuOuterWidth = $(".menu").outerWidth();
      let timeTdOuterWidth = $(".time-td").outerWidth();
      let contentTdOuterWidth = $(".content-td").outerWidth() * 7;
      let left = event.x - allLeftElementsWidth;
      if (left >= timeTdOuterWidth + contentTdOuterWidth - editMenuOuterWidth) {
        left = left - (editMenuOuterWidth - 10);
      }
      this.top = top + "px";
      this.left = left + "px";
    },
    closeEditMenu() {
      $("#editMenu").hide();
    },
    //main function
    getEventByWeek() {
      let param = {
        Token: this.tokenObj.Token,
        InstructorId: this.instructorId,
        Date: this.selectedDate,
        SelectedCountries: this.selectedCountries,
      };
      API.schedule
        .getEventByWeek(param)
        .then((response) => {
          if (response.data.success) {
            this.data = response.data.data;
            this.$nextTick(() => {
              this.loadCalendar(this.data);
            });
            window.setTimeout(() => {
              this.loadCalendar(this.data);
            }, 100);
          } else {
            this.$swal(response.data.message, {
              icon: "error",
            });
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    loadCalendar(data) {
      for (let index = 0; index < data.length; index++) {
        let events = data[index].Events;
        if (!events || !events.length) continue;
        //adjust width and left
        let timeTdOuterWidth = $(".time-td").outerWidth();
        let contentTdOuterWidth = $(".content-td").outerWidth();
        let additionalContentTdWidth = contentTdOuterWidth * index;
        let alreadyCheckedIndex = [];
        for (let i = 0; i < events.length; i++) {
          if (alreadyCheckedIndex.includes(i)) continue;
          let minTotalStartTimeMinutes = events[i].TotalStartTimeMinutes;
          let maxTotalEndTimeMinutes = events[i].TotalEndTimeMinutes;
          let overlapEvents = [];
          overlapEvents.push(events[i]);
          alreadyCheckedIndex.push(i);
          for (let j = 0; j < events.length; j++) {
            if (i == j || alreadyCheckedIndex.includes(j)) continue;
            let totalStartTimeMinutes = events[j].TotalStartTimeMinutes;
            let totalEndTimeMinutes = events[j].TotalEndTimeMinutes;
            if (
              totalStartTimeMinutes >= minTotalStartTimeMinutes &&
              totalStartTimeMinutes < maxTotalEndTimeMinutes
            ) {
              overlapEvents.push(events[j]);
              alreadyCheckedIndex.push(j);
              if (totalEndTimeMinutes > maxTotalEndTimeMinutes) {
                maxTotalEndTimeMinutes = totalEndTimeMinutes;
              }
            }
          }

          if (!overlapEvents.length) continue;
          let eachElemWidth = contentTdOuterWidth / overlapEvents.length;
          this.$nextTick(() => {
            for (let x = 0; x < overlapEvents.length; x++) {
              let width = eachElemWidth;
              if (overlapEvents[x].IsPublicHoliday) width = width + 1;
              $(`#event${overlapEvents[x].Id}`).outerWidth(`${width}px`);
              let left =
                timeTdOuterWidth + additionalContentTdWidth + x * eachElemWidth;
              $(`#event${overlapEvents[x].Id}`).css("left", `${left}px`);
            }
          });
        }
        //adjust height and top
        let headerDateOuterHeight = $(".header-date").outerHeight();
        this.$nextTick(() => {
          for (let item of events) {
            let duration =
              item.TotalEndTimeMinutes - item.TotalStartTimeMinutes;
            $(`#event${item.Id}`).outerHeight(`${duration}px`);
            $(`#event${item.Id}`).css(
              "top",
              `${item.TotalStartTimeMinutes + headerDateOuterHeight}px`
            );
          }
        });
      }
    },
    save() {
      //validation
      if (
        (this.startHour != "" || this.startMinute != "") &&
        (this.endHour != "" || this.endMinute != "")
      ) {
        let startHour = this.startHour != "" ? parseInt(this.startHour) : 0;
        let startMinute =
          this.startMinute != "" ? parseInt(this.startMinute) : 0;
        let totalStartTimeMinutes =
          (this.startTimePart == "AM"
            ? startHour == 12
              ? 0
              : startHour
            : startHour < 12
            ? startHour + 12
            : 12) *
            60 +
          startMinute;

        let endHour = this.endHour != "" ? parseInt(this.endHour) : 0;
        let endMinute = this.endMinute != "" ? parseInt(this.endMinute) : 0;
        let totalEndTimeMinutes =
          (this.endTimePart == "AM"
            ? endHour == 12
              ? 0
              : endHour
            : endHour < 12
            ? endHour + 12
            : 12) *
            60 +
          endMinute;

        if (totalEndTimeMinutes <= totalStartTimeMinutes) {
          this.$swal("End Time must be later than Start Time", {
            icon: "error",
          });
          return;
        }
      }
      //save
      let param = {
        Token: this.tokenObj.Token,
        Id: this.id,
        EventName: this.eventName,
        Location: this.location,
        CalendarDate: this.date,
        StartHour: this.startHour,
        StartMinute: this.startMinute,
        StartTimePart: this.startTimePart,
        EndHour: this.endHour,
        EndMinute: this.endMinute,
        EndTimePart: this.endTimePart,
        Notes: this.notes,
      };
      API.schedule
        .saveEvent(param)
        .then((response) => {
          if (!response.data.success)
            this.$swal(response.data.message, { icon: "error" });
          if (response.data.success) {
            this.getEventByWeek();
            $("#addEvent").modal("hide");
          }
        })
        .catch((error) => {
          this.$swal(error.response.data.Message, { icon: "error" });
        });
    },
    remove() {
      let param = {
        Token: this.tokenObj.Token,
        Id: this.id,
      };
      API.schedule
        .deleteEvent(param)
        .then((response) => {
          if (!response.data.success)
            this.$swal(response.data.message, { icon: "error" });
          if (response.data.success) {
            this.getEventByWeek();
            $("#editMenu").hide();
          }
        })
        .catch((error) => {
          this.$swal(error.response.data.Message, { icon: "error" });
        });
    },
  },
  created() {
    this.getEventByWeek();
  },
  mounted() {
    this.updateScrollTop();
    window.addEventListener("scroll", this.updateScrollTop);
    window.addEventListener("resize", this.updateCalendar);
    //scroll to next available event
    window.setTimeout(() => {
      let earliestEvent = { Id: "", TotalStartTimeMinutes: 9999 };
      if (this.data && this.data.length) {
        for (let item of this.data) {
          if (
            item.Events &&
            item.Events.length &&
            item.Events[0].TotalStartTimeMinutes <
              earliestEvent.TotalStartTimeMinutes
          ) {
            earliestEvent = item.Events[0];
          }
        }
        if (earliestEvent.Id) {
          this.$nextTick(() => {
            $(document).scrollTop(
              $(`#event${earliestEvent.Id}`).position().top
            );
          });
        }
      }
    }, 200);
    //adjust word-spacing
    let userAgent = navigator.userAgent;
    let platform = navigator.userAgentData.platform || navigator.platform;
    let isWindow = /Win/i.test(platform);
    let isAndroid = /Android/i.test(userAgent);
    let isSafari = /^((?!chrome|android).)*safari/i.test(userAgent);
    let isMacos = /Mac/i.test(platform);
    if (isWindow || isAndroid || (isMacos && !isSafari)) {
      $(".table thead th").css("word-spacing", "-5px");
    }
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.updateScrollTop);
    window.removeEventListener("resize", this.updateCalendar);
  },
};
</script>

<style scoped>
.table-responsive {
  position: relative;
}
table {
  table-layout: fixed;
}
.table thead th {
  letter-spacing: -0.5px;
  font-size: 13px;
  text-align: center;
}
.table.custom-table > thead > tr > th.time-td {
  width: 45px;
}
.table.custom-table > thead > tr > th {
  padding-left: 0 !important;
  padding-right: 0 !important;
}
.table.custom-table > tbody > tr > td.time-td {
  color: #495057;
  background-color: #e9ecef;
  vertical-align: top !important;
  padding-top: 1px !important;
  padding-right: 3px !important;
  text-align: right !important;
  height: 60px;
  width: 45px;
  font-size: 13px;
}
.table.custom-table > tbody > tr > td {
  padding: 0 !important;
  height: 60px;
}
.table.custom-table > tbody > tr > td.content-td {
  cursor: pointer;
}

.event-div {
  position: absolute;
  color: white;
  padding: 2px;
  line-height: 10px;
  overflow: auto;
  cursor: pointer;
}
.time-span {
  letter-spacing: -0.5px;
  font-size: 9px;
}
.event-span {
  font-size: 10px;
}
.menu {
  max-width: fit-content;
  border: 1px solid lightgrey;
  background: #fafafa;
  display: block;
  position: absolute;
  z-index: 99;
  font-size: 11px;
}
.menu-item {
  padding-left: 5px;
  padding-right: 5px;
  padding-top: 1px;
  cursor: pointer;
}
.menu-item:hover {
  background: #d0d0d0;
}
.border-gray {
  border: 1px solid #dee2e6;
}
.selected {
  border: 2px solid black;
}
</style>


// WEBPACK FOOTER //
// src/components/SchoolUser/Other/MyCalendarWeek.vue